import React from 'react'
import { Toggle } from '@/components/atoms'
import { REWARD_TYPES, isInventoryManagedRewardType } from '@/utils/constants/rewardsConstants'
import { displayOutOfStockSchema, inStockSchema, unlimitedInventorySchema } from '../schemas'

/**
 * ToggleRow component - Reusable wrapper for all toggle switches in a row
 * Conditionally shows unlimited inventory toggle for Cash/Product/Physical reward types
 * @param {Object} props - Component props
 * @param {Object} props.formData - Form data containing displayOutOfStock, inStock, unlimitedInventory, rewardType
 * @param {Function} props.handleDisplayOutOfStockChange - Function to handle form field changes
 * @param {Function} props.handleUnlimitedInventoryChange - Function to handle form field changes
 * @param {Function} props.handleInStockChange - Function to handle form field changes
 * @returns {JSX.Element} The rendered ToggleRow component
 */
const ToggleRow = ({ formData, handleDisplayOutOfStockChange, handleUnlimitedInventoryChange, handleInStockChange}) => {
  // Check if reward type supports inventory to show unlimited inventory toggle.
  // Guard against undefined so we don't accidentally match mocked undefined constants.
  const inventoryRewardType = formData?.rewardType
  const showUnlimitedInventory =
    !!inventoryRewardType &&
    (
      // Preserve previous behavior: VISA_CARD always shows unlimited inventory toggle
      inventoryRewardType === REWARD_TYPES.VISA_CARD ||
      isInventoryManagedRewardType(inventoryRewardType, formData?.rewardCardType)
    )


  return (
    <div className="flex flex-col md:flex-row items-start gap-6">

       {/* Unlimited Inventory Toggle - Only shown for Cash/Product/Physical/VISA_CARD/DIGITAL/DIGITAL_PRE_ORDER/LOYALTY/PEP_VOUCHER_DISCOUNT */}
      {showUnlimitedInventory && (
        <div className="w-[194px] mr-[70px]">
          <Toggle
            value={formData?.unlimitedInventory || false}
            updateValue={handleUnlimitedInventoryChange}
            uiSchema={unlimitedInventorySchema}
            id="unlimited_inventory"
          />
        </div>
      )}

      {/* Display Out of Stock Toggle */}
      <div className="w-[194px] mr-[70px]">
        <Toggle
          value={formData?.displayOutOfStock || false}
          updateValue={handleDisplayOutOfStockChange}
          uiSchema={displayOutOfStockSchema}
          id="display_out_of_stock"
        />
      </div>

      {/* In Stock Toggle */}
      <div>
        <Toggle
          value={formData?.inStock || false}
          updateValue={handleInStockChange}
          uiSchema={inStockSchema}
          id="in_stock"
        />
      </div>
    </div>
  )
}

export default ToggleRow

